// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.card-default-list[data-v-54a843a1]{min-height:32.6rem}@media (max-width:767px){.card-default-list[data-v-54a843a1]{min-height:18.4rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
